// import universalLanguageDetect from '@unly/universal-language-detector';
// import * as Sentry from '@sentry/browser';
// import get from 'lodash/get';
import NextCookies from 'next-cookies';

export function detectLanguage(ctx) {
    const cookies = NextCookies(ctx);
    return {
        lang: ctx.locale,
        cookies
    };

    // const { req } = ctx;

    // return {
    //     lang: universalLanguageDetect({
    //         supportedLanguages: ['pl', 'en'],
    //         fallbackLanguage: 'pl', // Fallback language in case the user's language cannot be resolved
    //         acceptLanguageHeader: get(req, 'headers.accept-language'),
    //         serverCookies: cookies,
    //         errorHandler: (error) => {
    //         // Example if using Sentry in your app:
    //             Sentry.withScope((scope) => {
    //                 scope.setExtra('origin', origin);
    //                 scope.setContext('context', ctx);
    //                 Sentry.captureException(error);
    //             });
    //         }
    //     }),
    //     cookies
    // };
}
